import { render, staticRenderFns } from "./life-go-card.vue?vue&type=template&id=7f657ff5&scoped=true&lang=pug&"
import script from "./life-go-card.vue?vue&type=script&lang=js&"
export * from "./life-go-card.vue?vue&type=script&lang=js&"
import style0 from "./life-go-card.vue?vue&type=style&index=0&id=7f657ff5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f657ff5",
  null
  
)

export default component.exports